import {
  buildDataProvider,
  // AmplifyFilter
} from "react-admin-amplify";
import { updateLambdaPickListItem } from "../managerApp/resources/outboundShipments/lineItem/PickListItemUtils";
import {
  createLambdaOutboundShipment,
  updateLambdaOutbound,
} from "../managerApp/resources/outboundShipments/OutboundUtils";
import {
  createLambdaInbound,
  lambdaSaveInbound,
} from "../managerApp/resources/inboundShipments/InboundUtils";
import { saveInvoiceForm } from "../managerApp/resources/invoices/saveInvoiceChange";
import { handleUnauthorizedError } from "../utils/appUtils";
import { isUserFacingError } from "../utils/lambdaErrors";

import * as mutations from "../graphql/mutations";
import { createInventoryItem } from "../graphql/inventory/custom-mutations";
import { updateReloadYard } from "../graphql/reloadyard/custom-mutations";

import * as queries from "../graphql/queries";

import {
  getCarrier,
  getCarrierCompany,
  getCarrierUser,
  reloadYardCarrierByActiveByTypeByName,
} from "../graphql/carrier/carrier-queries";
import {
  createCarrierWithIdentifiers,
  updateCarrierCompanyProfile,
  updateCarrierWithIdentifiers,
} from "../graphql/carrier/carrier-mutations";
import {
  getInvoice,
  invoiceByActiveByStatusByDateByAccount,
  invoiceByAccountByActiveByStatusByDate,
  searchInvoices,
} from "../graphql/invoice/invoice-queries";
import {
  getInboundShipment,
  inboundShipmentByReloadYardByStatusByDates,
  inboundShipmentByAccountByStatusByDates,
  inboundShipmentByCarrierByStatusByDates,
  searchInboundShipments,
} from "../graphql/inbound/custom-queries";
import {
  getInventorie,
  inventoryByStatusByAccountByProductByLot,
  inventoryByStatusByAccountIdByProductByLot,
  searchInventorys,
  getInventoryItem,
} from "../graphql/inventory/custom-queries";
import {
  getOutboundShipment,
  outboundShipmentByReloadYardByStatusByDates,
  outboundShipmentByAccountByStatusByDates,
  outboundShipmentByCarrierByStatusByDates,
  searchOutboundShipments,
  getShipmentLineItem,
} from "../graphql/outbound/custom-queries";
import { getReloadYard } from "../graphql/reloadyard/custom-queries";
import {
  customerByReloadYardByActiveByAccountNameByName,
  getCustomer,
  searchCustomerReloadYardAccounts,
} from "../graphql/user/user-queries";
import {
  sanitizeOutbound,
  sanitizeShipmentLineItem,
} from "../graphql/outbound/outboundCRUD";
import {
  sanitizeInbound,
  sanitizeInboundRecord,
} from "../graphql/inbound/inboundCRUD";
import { sanitizeCarrier } from "../graphql/carrier/carrierCRUD";
import { searchHelpPages } from "../graphql/helpPage/helpPage-queries";
import { productByAccountByActiveByName } from "../graphql/account/account-queries";

const newQueries = {
  ...queries,
  customerByReloadYardByActiveByAccountNameByName,
  getCarrier,
  getCarrierCompany,
  getCarrierUser,
  getCustomer,
  getReloadYard,
  getInboundShipment,
  getInvoice,
  getOutboundShipment,
  getInventorie,
  getInventoryItem,
  getShipmentLineItem,
  inventoryByStatusByAccountByProductByLot,
  inventoryByStatusByAccountIdByProductByLot,
  inboundShipmentByReloadYardByStatusByDates,
  inboundShipmentByAccountByStatusByDates,
  inboundShipmentByCarrierByStatusByDates,
  invoiceByActiveByStatusByDateByAccount,
  invoiceByAccountByActiveByStatusByDate,
  outboundShipmentByReloadYardByStatusByDates,
  outboundShipmentByAccountByStatusByDates,
  outboundShipmentByCarrierByStatusByDates,
  productByAccountByActiveByName,
  reloadYardCarrierByActiveByTypeByName,
  searchCustomerReloadYardAccounts,
  searchInboundShipments,
  searchInventorys,
  searchInvoices,
  searchOutboundShipments,
  searchProducts: queries.searchProducts,
  searchHelpPages,
};

const newMutations = {
  ...mutations,
  // Both spread after `mutations`, so the pair that selects the carrier's
  // identifiers wins over the generated one of the same name.
  createCarrier: createCarrierWithIdentifiers,
  updateCarrier: updateCarrierWithIdentifiers,
  // The carrier portal's Company Profile is the only writer of a company record
  // from the client — everything else about one is decided by handleCarrierChange
  // off the yard entries.
  updateCarrierCompany: updateCarrierCompanyProfile,
  updateReloadYard,
  createInventoryItem,
};

const dataProvider = buildDataProvider({
  queries: newQueries,
  mutations: newMutations,
});

// Wrapper function to catch 401 errors from dataProvider methods
const wrapDataProviderMethod = (method) => {
  return async (...args) => {
    try {
      return await method(...args);
    } catch (error) {
      // Check for 401 errors and handle them
      const { isTokenRefreshInProgress } = require("../utils/appUtils");
      const handled = handleUnauthorizedError(error);
      // If handleUnauthorizedError returns a promise (refresh in progress), await it
      const wasHandled = handled instanceof Promise ? await handled : handled;

      if (wasHandled) {
        // Re-throw to prevent further processing
        throw new Error("Unauthorized - Session expired");
      }

      // The retry below exists for one thing: a call that failed on an expired
      // token and would succeed on a fresh one. A userFacing error is the
      // lambda's considered answer — the shipment moved, the slot went — so a
      // second attempt cannot come back any different, and these are writes: the
      // schedule conflict re-POSTed the whole appointment transaction, to be
      // rejected by the same conditions a second time. Stop at the first answer.
      if (isUserFacingError(error)) throw error;

      // If not handled and refresh completed, retry the request once
      if (!wasHandled && !isTokenRefreshInProgress()) {
        console.log("Retrying dataProvider request after token refresh...");
        try {
          return await method(...args);
        } catch (retryError) {
          const retryHandled = handleUnauthorizedError(retryError);
          const retryWasHandled =
            retryHandled instanceof Promise ? await retryHandled : retryHandled;
          if (retryWasHandled) {
            throw new Error("Unauthorized - Session expired");
          }
          throw retryError;
        }
      }

      throw error;
    }
  };
};

export const myDataProvider = {
  ...dataProvider,
  getList: wrapDataProviderMethod(async (resource, params) => {
    debugger;
    const data = await dataProvider.getList(resource, params);
    return data;
  }),
  getOne: wrapDataProviderMethod(async (resource, params) => {
    debugger;
    const data = await dataProvider.getOne(resource, params);
    return data;
  }),
  getMany: wrapDataProviderMethod(async (resource, params) => {
    return await dataProvider.getMany(resource, params);
  }),
  getManyReference: wrapDataProviderMethod(async (resource, params) => {
    return await dataProvider.getManyReference(resource, params);
  }),
  create: wrapDataProviderMethod(async (resource, params) => {
    if (resource === "outboundShipments" && params.data.__saveContext) {
      // Copy the record instead of deleting __saveContext off params.data: the
      // token-refresh retry in wrapDataProviderMethod re-invokes with the SAME
      // params object, and a stripped flag sends that second attempt down the
      // plain AppSync create below. That leg rejects the unsanitized form
      // record with "contains a field that is not defined for input object
      // type", masking whatever the lambda actually failed on.
      const { __saveContext, ...data } = params.data;
      const { photos, selectedTimeslot, toAccount } = __saveContext;
      // Single writer: the lambda transactionally writes the parent
      // OutboundShipment plus all children, inventory commits, photos,
      // track car and charges. No AppSync createOutboundShipment leg — a
      // lambda failure leaves no orphan parent, and a retry mints a fresh id.
      const response = await createLambdaOutboundShipment(data, {
        photos,
        selectedTimeslot,
        toAccount,
      });
      if (response.error) throw response.error;
      return { data: sanitizeOutbound(data) }; // RA create contract: full record incl. id
    }
    if (resource === "inboundShipments" && params.data.__saveContext) {
      // Copy rather than mutate params.data — see the outbound branch above.
      const { __saveContext, ...data } = params.data;
      const { photos, account, selectedTimeslot } = __saveContext;
      // Single writer: the lambda transactionally writes the parent
      // InboundShipment plus all children, inventory, photos, track car and
      // charges. No AppSync createInboundShipment leg — a lambda failure
      // leaves no orphan parent, and a retry mints a fresh id.
      const response = await createLambdaInbound(data, {
        photos,
        account,
        selectedTimeslot,
      });
      if (response.error) throw response.error;
      return { data: sanitizeInboundRecord(data) }; // RA create contract: full record incl. id
    }
    return await dataProvider.create(resource, params);
  }),
  update: wrapDataProviderMethod(async (resource, params) => {
    if (resource === "shipmentLineItems") {
      const { data, previousData } = params;
      debugger;

      // Call the lambda function to update the pick list item
      const response = await updateLambdaPickListItem(
        previousData, // record
        data.outboundShipment,
        data,
      );
      if (response.error) throw response.error;
      return { data: sanitizeShipmentLineItem(data) };
    } else if (resource === "outboundShipments" && params.data.__saveContext) {
      const { previousData } = params;
      // Copy rather than mutate params.data — see the create branch above.
      const { __saveContext, ...data } = params.data;
      const {
        isAdvance = false,
        isRollback = false,
        scheduleOnly = false,
        historyAppendList,
        trackCarPullId = null,
        trackCarRestoreId = null,
      } = __saveContext;

      // Single writer: the lambda transactionally writes the outbound record
      // (full dynamic update) plus all line items and inventory aggregates.
      // scheduleOnly narrows that to the appointment and its header fields —
      // the carrier dispatch form edits one field and must not re-send a form
      // snapshot of the pick list and inventory over newer yard edits.
      const response = await updateLambdaOutbound(
        previousData, // record — DB state; in pessimistic mode still accurate on retry
        data,
        isAdvance,
        isRollback,
        false,
        scheduleOnly
          ? { scheduleOnly: true, historyAppendList }
          : { fullUpdate: true, trackCarPullId, trackCarRestoreId },
      );
      if (response.error) throw response.error;
      // Form-only flag consumed by updateLambdaOutbound (addressCreateInput).
      delete data.saveAddress;
      return { data: sanitizeOutbound(data) };
    } else if (resource === "inboundShipments" && params.data.__saveContext) {
      const { previousData } = params;
      // Copy rather than mutate params.data — see the create branch above.
      const { __saveContext, ...data } = params.data;
      const {
        isRollback = false,
        scheduleOnly = false,
        historyAppendList,
        trackCarPullId = null,
        trackCarRestoreId = null,
      } = __saveContext;

      // Single writer: parent (dynamic full update) + inventories + items +
      // seals + charges + track car in one lambda transaction set. scheduleOnly
      // narrows that to the appointment and its header fields — see the
      // outbound branch above.
      await lambdaSaveInbound(
        previousData,
        data,
        isRollback,
        scheduleOnly
          ? { scheduleOnly: true, historyAppendList }
          : { fullUpdate: true, trackCarPullId, trackCarRestoreId },
      ); // throws on lambda error
      return { data: sanitizeInboundRecord(data) };
    } else if (resource === "inboundShipments") {
      // Plain AppSync update (no __saveContext): strip @connection objects
      // (timeslot, account, …) the scheduling forms attach to the record.
      const data = await dataProvider.update(resource, {
        ...params,
        data: sanitizeInbound(params.data),
        previousData: params.previousData
          ? sanitizeInbound(params.previousData)
          : params.previousData,
      });
      return data;
    } else if (resource === "invoices" && params.data.__saveContext) {
      // The invoice form's save. Written with an updatedAt check so a payment,
      // Complete or Reopen landing while the form saves isn't undone; see
      // saveInvoiceForm. Other invoice updates (admin tools) take the plain path.
      const { __saveContext, ...data } = params.data;
      const saved = await saveInvoiceForm(data, newMutations.updateInvoice);
      return { data: saved };
    } else if (resource === "carriers") {
      // The edit form submits the whole record, and companyId is admin-write-only
      // at the field level — sent back even unchanged, the save is refused whole.
      // The stamp is handleCarrierChange's; the form never owned it.
      const data = await dataProvider.update(resource, {
        ...params,
        data: sanitizeCarrier(params.data),
        previousData: params.previousData
          ? sanitizeCarrier(params.previousData)
          : params.previousData,
      });
      return data;
    } else {
      const data = await dataProvider.update(resource, params);
      return data;
    }
  }),
  updateMany: wrapDataProviderMethod(async (resource, params) => {
    return await dataProvider.updateMany(resource, params);
  }),
  delete: wrapDataProviderMethod(async (resource, params) => {
    return await dataProvider.delete(resource, params);
  }),
  deleteMany: wrapDataProviderMethod(async (resource, params) => {
    return await dataProvider.deleteMany(resource, params);
  }),
};
